import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import { Dispatch } from 'redux';
import AlertContainer from '../components/alerts/AlertContainer';
import { isLoggedIn, themeBackgroundImage } from '../stores/auth/selectors';
import { RootState } from '../stores/store';
import DefaultRedirect from './DefaultRedirect';

interface Props extends LocalizeContextProps, RouteProps {
    title?: string;
    filter?: boolean;

    loggedIn: boolean;
}

class PrivateRoute extends React.Component<Props> {

    public render() {
        if (this.props.title !== undefined && document.title !== this.props.title) {
            document.title = this.props.title;
        }

        const { loggedIn, children, filter, ...rest } = this.props;
        if (loggedIn && (filter === undefined || filter === true)) {
            return (
                <Route
                    {...rest}
                />
            );
        } else {
            return <DefaultRedirect />;
        }
    }
}

const mapStateToProps = (
    state: RootState,
) =>
    ({
        loggedIn: isLoggedIn(state),
    });

const mapDispatchToProps = (dispatch: Dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(PrivateRoute));
